import allStates from '../setup/state-abbreviations'

const emailValidation = value => {
  let isValidated = false
  let message = 'Required'

  // If the input has a value
  if (value) {
    // Check for email address format
    isValidated = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)

    // If the value didn't pass validation, set error message
    if (!isValidated) {
      message = 'Please enter a valid email address.'
    }
  }

  return { isValidated, message }
}

const zipCodeValidation = value => {
  let isValidated = false
  let message = 'Required'

  // If the input has a value
  if (value) {
    // Check for exactly 5 numbers
    let has5Digits = /^[0-9]{5}$/.test(value)
    if (!has5Digits) {
      message = 'Must enter valid 5-digit zip code.'
    }

    // Check for numbers only
    let numbersOnly = /^[0-9]+$/.test(value)
    if (!numbersOnly) {
      message = 'Zip code must contain numbers only.'
    }

    // If the value didn't pass validation, set error message
    if (has5Digits && numbersOnly) {
      isValidated = true
    }
  }

  return { isValidated, message }
}

const ssnValidation = value => {
  let isValidated = false
  let message = 'Required'

  // If the input has a value
  if (value) {
    // Check for exactly 4 numbers
    let has4Digits = /^[0-9]{4}$/.test(value)
    if (!has4Digits) {
      message = 'Must enter valid 4-digit SSN.'
    }

    // Check for numbers only
    let numbersOnly = /^[0-9]+$/.test(value)
    if (!numbersOnly) {
      message = 'SSN must contain numbers only.'
    }

    // If the value didn't pass validation, set error message
    if (has4Digits && numbersOnly) {
      isValidated = true
    }
  }

  return { isValidated, message }
}

const cityValidation = value => {
  let isValidated = false
  let message = 'Required'

  // If the input has a value
  if (value) {
    // Check for letters only, spaces in names
    isValidated = /^[a-z ][A-Z ]+$/i.test(value)

    // If the value didn't pass validation, set error message
    if (!isValidated) {
      message = 'Please enter a valid US city.'
    }
  }

  return { isValidated, message }
}

const findState = (state, value) => {
  return (
    value.toLowerCase() === state.abbreviation.toLowerCase() ||
    value.toLowerCase() === state.name.toLowerCase()
  )
}

const stateValidation = value => {
  let isValidated = false
  let message = 'Required'

  if (value) {
    // Determine if value matches a state name or abbreviation.
    if (allStates.find(state => findState(state, value))) {
      isValidated = true
    }

    if (!isValidated) {
      message = 'Please provide a valid state'
    }
  }
  return { isValidated, message }
}

const nameValidation = value => {
  let isValidated = false
  let message = 'Required'

  // If the input has a value
  if (value) {
    // Check for letters, spaces, commas, apostrophes, hyphens, and periods only
    isValidated = /^[a-z ,.'-]+$/i.test(value)

    // If the value didn't pass validation, set error message
    if (!isValidated) {
      message =
        'Names must only contain letters, hyphens, apostrophes, commas, periods, and spaces.'
    }
  }

  return { isValidated, message }
}

const passwordValidation = value => {
  let isValidated = false
  let message = 'Required'
  let validations = {}

  // Check for min. 8 digits
  validations.min8Digits = /.{8,}/.test(value)
  // One uppercase letter
  validations.minUppercase = /[A-Z]/.test(value)
  // One lowercase letter
  validations.minLowercase = /[a-z]/.test(value)
  // One number
  validations.minNumber = /\d/.test(value)
  // One special character #?!@$%^&*-
  validations.minSpecialChar = /[#?!@$%^&*-]/.test(value)

  // If all of the validations passed then it is validated, else set error message
  if (
    validations.min8Digits &&
    validations.minUppercase &&
    validations.minLowercase &&
    validations.minNumber &&
    validations.minSpecialChar
  ) {
    isValidated = true
  } else {
    message = value
      ? 'Password does not meet password requirements.'
      : 'Required'
  }

  return { isValidated, validations, message }
}

const phoneValidation = value => {
  let isValidated = false
  let message = 'Required'

  // if ten numbers
  if (/^[(]?[0-9]{3}[)]?[\s]?[0-9]{3}[-]?[0-9]{4}$/.test(value)) {
    isValidated = true
  } else {
    message = value ? 'Please enter a 10-digit phone number' : 'Required'
  }
  return { isValidated, message }
}

const moneyValidation = value => {
  let isValidated = false
  let message = 'Required'

  // if only numbers
  if (/^[0-9,]+$/.test(value)) {
    isValidated = true
  } else {
    message = value ? 'Please enter numbers only' : 'Required'
  }
  return { isValidated, message }
}

const defaultValidation = value => {
  let isValidated = Boolean(value)
  let message = 'Required'
  return { isValidated, message }
}

export {
  emailValidation,
  zipCodeValidation,
  ssnValidation,
  cityValidation,
  stateValidation,
  nameValidation,
  passwordValidation,
  phoneValidation,
  moneyValidation,
  defaultValidation
}
